"use client";
import { useEffect, useState } from "react";
import { Icon } from "./icons";
export function TasksView() {
  const [records, setRecords] = useState<
    { id: string; title: string; due_at?: string; status: string }[]
  >([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch("/api/tasks")
      .then((response) => (response.ok ? response.json() : { tasks: [] }))
      .then((data) => setRecords(data.tasks))
      .finally(() => setLoading(false));
  }, []);
  return (
    <section className="module-view" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:16:5"}>
      <div className="module-heading" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:17:7"}>
        <div data-amazi-id={"crm/src/features/crm/tasks-view.tsx:18:9"}>
          <div className="breadcrumb" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:19:11"}>
            Рабочее пространство <span data-amazi-id={"crm/src/features/crm/tasks-view.tsx:20:34"}>/</span> Задачи мастеров
          </div>
          <h1 data-amazi-id={"crm/src/features/crm/tasks-view.tsx:22:11"}>Задачи мастеров</h1>
          <p data-amazi-id={"crm/src/features/crm/tasks-view.tsx:23:11"}>Рабочие уточнения, примерки и контроль сроков</p>
        </div>
        <button className="primary-button" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:25:9"}>
          <Icon name="plus" size={16} data-amazi-jsx-id={"crm/src/features/crm/tasks-view.tsx:26:11"} /> Новая задача
        </button>
      </div>
      <div className="task-filters" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:29:7"}>
        <button className="filter-active" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:30:9"}>
          Все задачи <b data-amazi-id={"crm/src/features/crm/tasks-view.tsx:31:22"}>{records.length}</b>
        </button>
        <button data-amazi-id={"crm/src/features/crm/tasks-view.tsx:33:9"}>
          Мои задачи <b data-amazi-id={"crm/src/features/crm/tasks-view.tsx:34:22"}>{records.filter((task) => task.status !== "done").length}</b>
        </button>
        <button data-amazi-id={"crm/src/features/crm/tasks-view.tsx:36:9"}>
          Просроченные{" "}
          <b data-amazi-id={"crm/src/features/crm/tasks-view.tsx:38:11"}>
            {
              records.filter(
                (task) =>
                  task.due_at && new Date(task.due_at) < new Date() && task.status !== "done",
              ).length
            }
          </b>
        </button>
      </div>
      <div className="panel task-list" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:48:7"}>
        {loading && <div className="empty-message" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:49:21"}>Загружаем задачи…</div>}
        {!loading && records.length === 0 && (
          <div className="empty-message" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:51:11"}>Задач пока нет. Создайте первую задачу для команды.</div>
        )}
        {records.map((task) => {
          const checked = task.status === "done";
          return (
            <div className={`managed-task ${checked ? "task-done" : ""}`} key={task.title} data-amazi-id={"crm/src/features/crm/tasks-view.tsx:56:13"}>
              <button
                className={`check-box ${checked ? "checked" : ""}`}
                onClick={async () => {
                  const response = await fetch(`/api/tasks/${task.id}`, {
                    method: "PATCH",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ status: checked ? "open" : "done" }),
                  });
                  if (response.ok)
                    setRecords((current) =>
                      current.map((item) =>
                        item.id === task.id ? { ...item, status: checked ? "open" : "done" } : item,
                      ),
                    );
                }}
               data-amazi-id={"crm/src/features/crm/tasks-view.tsx:57:15"}>
                {checked ? "✓" : ""}
              </button>
              <div className="task-copy" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:75:15"}>
                <strong data-amazi-id={"crm/src/features/crm/tasks-view.tsx:76:17"}>{task.title}</strong>
                <span data-amazi-id={"crm/src/features/crm/tasks-view.tsx:77:17"}>
                  <Icon name="calendar" size={13} data-amazi-jsx-id={"crm/src/features/crm/tasks-view.tsx:78:19"} />{" "}
                  {task.due_at ? new Date(task.due_at).toLocaleString("ru-RU") : "Без срока"}
                </span>
              </div>
              <div className="task-assignee avatar avatar-purple" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:82:15"}>—</div>
              <div className="priority gray" data-amazi-id={"crm/src/features/crm/tasks-view.tsx:83:15"}>{task.status}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
